module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._g(_vm._b({
    staticClass: "ui_icon",
    class: _vm.getCssClass,
    style: (_vm.getStyle)
  }, 'div', _vm.$attrs, false), _vm.$listeners), [_c(_vm.template, {
    tag: "component",
    staticClass: "ui_icon__template"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f799608","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppSvgIconNew/AppSvgIcon.vue
// module id = dade4f73520776f6d4e8
// module chunks = 89